import { Component, input } from '@angular/core';
import { AdminContractService, CollectionApi, ContractCluster } from '@shared/services/admin-contract.service';
import { ContractCollectionComponent } from '../contract-collection.component';
import { AdminClusterSelectorComponent } from '@shared/components/admin-cluster-selector/admin-cluster-selector.component';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { TypedTemplateDirective } from '@shared/directives/typed-template.directive';
import { BadgeOrganizationComponent } from '@shared/components/badge-organization/badge-organization.component';
import { TablePagerComponent } from '@shared/components/table-pager/table-pager.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-contract-clusters',
  templateUrl: './contract-clusters.component.html',
  styleUrls: ['./contract-clusters.component.scss'],
  imports: [
    AdminClusterSelectorComponent,
    NgxDatatableModule,
    TypedTemplateDirective,
    BadgeOrganizationComponent,
    TablePagerComponent,
    TranslatePipe,
  ],
})
export class ContractClustersComponent extends ContractCollectionComponent<ContractCluster> {
  public canBeEdited = input<boolean>(true);
  constructor(contractService: AdminContractService) {
    super(contractService);
  }

  override getCollectionApi(): CollectionApi<ContractCluster> {
    return this.admin.clusters(this.contractNumber);
  }

  protected getItemId(item: ContractCluster) {
    return item.uid;
  }
}
